import { computed, defineComponent, onMounted, ref, watch } from "vue";
import * as KlipApi from "@/api/klip-api.proxy";
import {useUserStore} from "@/app/shared/state/UserDataModule";
import {EUserRole} from '@/app/shared/state/user-role';
import {useKlipApiProxy} from '@/plugins/proxy-client';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlOrganisationInvoiceSettings',
    emits: ['update:refreshOrganisation'],
    props: {
        organisation: {
            type: Object as () => KlipApi.OrganisationDetail,
            required: true,
        }
    },
    setup(props, { emit }) {
        const viewModelLoading = ref<boolean>(true);
        const klipApiProxy = useKlipApiProxy();
        const organisationInvoiceData = ref<KlipApi.OrganisationInvoiceData>(null);
        const organisationInvoiceSettings = ref<KlipApi.InvoiceSettingsForOrganisation>(null);

        const isAdmin = computed((): boolean => {
            return useUserStore().hasRole([EUserRole.admin]);
        });

        const refreshOrganisation = async () => {
            emit('update:refreshOrganisation');
        };

        const changeInvoiceType = async  () => {
            await loadData();
        };

        const loadData = async () => {
            viewModelLoading.value = true;
            const invoiceDetails = await klipApiProxy.operations_GetOrganisationInvoiceDetail(props.organisation.organisationId);
            if (invoiceDetails.result) {
                organisationInvoiceData.value = invoiceDetails.result.organisationInvoiceData;
                organisationInvoiceSettings.value = invoiceDetails.result.invoiceSettings;
            }
            viewModelLoading.value = false;
        }

        onMounted(async () => {
            await loadData();
        });

        return {
            isAdmin,
            viewModelLoading,
            organisationInvoiceData,
            organisationInvoiceSettings,
            refreshOrganisation,
            changeInvoiceType,
        };
    }
});
